import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { Entity } from '@backstage/catalog-model';
import { rootRouteRef } from './routes';
import { herokuApiRef } from '@internal/backstage-plugin-heroku-react';
import { HerokuApiClient } from './api';

export const herokuPlugin = createPlugin({
  id: 'heroku',
  apis: [
    createApiFactory({
      api: herokuApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new HerokuApiClient(discoveryApi, fetchApi),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const HerokuPage = herokuPlugin.provide(
  createRoutableExtension({
    name: 'HerokuPage',
    component: () => import('./components/Pipeline').then(m => m.Pipeline),
    mountPoint: rootRouteRef,
  }),
);

/**
 * Helper function to determine whether or not to show the Heroku page for a
 * given entity
 *
 * @param entity The entity to check
 * @returns Whether or not the Heroku page should be shown for this entity
 */
export function showHerokuTab(entity: Entity): boolean {
  // Currently the Heroku tab shows pipeline data, so we show it only if a
  // pipeline UUID is available
  const appName = entity?.metadata?.annotations?.['heroku.com/pipeline-uuid'];

  return !!appName && entity.kind === 'Component';
}
